<template>
    <div>
        <h1 style="font-size: 24px; color: black;">首页配置</h1>
        <el-tabs type="card" v-model="selectedStyleIndexString" @tab-click="changeStyle" >
            <el-tab-pane v-for="style in this.newStyles"  :name="style.id+''" :key="style.id" :label="style.name">
            </el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;">
            <el-row  >
                <el-col :span="5">
                       <span> 渠道： </span>
                    <el-cascader v-model="queryData.subChannels" :options="channelList" :props="optionProps" clearable collapse-tags >
                    </el-cascader>
                </el-col>
                <el-col :span="8">
                    <el-button type="primary" @click="searchListRules">查询</el-button>
                    <el-button  type="success" v-if="selectedStyleIndex===2 " @click="handleEdit('新增榜单')">新增榜单</el-button>
                    <el-button  type="success" v-if="selectedStyleIndex===3 " @click="handleEdit('新增联动推荐')">新增推荐</el-button>
                    <el-button  type="success" v-if="selectedStyleIndex!==2 && selectedStyleIndex!==3" @click="handleEdit('新增版块')">新增版块</el-button>
                </el-col>
            </el-row>
        </div>
        <div>
            <el-table
                    border
                    :fit="true"
                    :row-class-name="tableRowClass"
                    :data="rules">
                <el-table-column v-if="selectedStyleIndex!==3" prop="rank" label="排序位置"></el-table-column>
                <el-table-column prop="id" label="版块ID"></el-table-column>
                <el-table-column prop="name" label="版块名称"></el-table-column>
                <el-table-column  v-if="selectedStyleIndex!==undefined" label="绑定渠道" :width="300"  :show-overflow-tooltip="false" >
                    <template slot-scope="scope" v-if="selectedStyleIndex!==undefined">
                        {{ scope.row.subChannels.length===subChannels.length?'全部':scope.row.subChannelNames.join(" , ") | ellipsis(50)}}
                    </template>
                </el-table-column>
                <el-table-column v-if="selectedStyleIndex!==2 && selectedStyleIndex!==3" prop="plateStyleEnum.name" label="版块样式"></el-table-column>
                <el-table-column v-if="selectedStyleIndex===0 " prop="indexNum" label="首页展示"></el-table-column>
                <el-table-column v-if="selectedStyleIndex===0 " prop="totalNum" label="展示总数"></el-table-column>
                <el-table-column v-if="selectedStyleIndex===0 || selectedStyleIndex===3" label="总数量">
                    <template slot-scope="scope" v-if="selectedStyleIndex!==undefined" >
                        {{(scope.row.games.length>0?scope.row.games.length:0)+scope.row.indexNum+scope.row.sysRecommend}}
                    </template>
                </el-table-column>
                <el-table-column v-if="selectedStyleIndex!==undefined" label="选品数量">
                    <template slot-scope="scope" v-if="selectedStyleIndex!==undefined" >
                        {{scope.row.games.length>0?scope.row.games.length:0}}
                    </template>
                </el-table-column>
                <el-table-column v-if="selectedStyleIndex===3 " prop="indexNum" label="系统推荐"></el-table-column>
                <el-table-column v-if="selectedStyleIndex===0 " prop="sysRecommend" label="系统推荐"></el-table-column>
                <el-table-column v-if="selectedStyleIndex!==3 " label="排序" align="center" >
                  <template slot-scope="scope" v-if="selectedStyleIndex!==3">
                      <!--<i v-if="scope.$index!==0" @click="handleRank('up', scope.row.id)" class="el-icon-arrow-up" style="padding: 5px;"/>
                      <i v-if="scope.$index!==rules.length-1" @click="handleRank('down', scope.row.id)" class="el-icon-arrow-down" style="padding: 5px;"/>-->
                         <el-input-number size="small" :min="0" style="width: 120px" v-model="scope.row.rank" @change="handleRank(scope.row.id,scope.row.rank)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="开关" align="center" width="150px">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.state"
                               :active-value="1"
                               :inactive-value="0"
                               active-text="开启"
                               inactive-text="关闭"
                               @change="update(scope.row)">
                    </el-switch>
                </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="300px">
                    <template slot-scope="scope">
                        <el-button
                                v-if="selectedStyleIndex!==2 && selectedStyleIndex!==3"
                                size="mini"
                                type="primary"
                                @click="handleEdit('编辑版块', scope.row)">编辑</el-button>
                        <el-button
                                v-if="selectedStyleIndex===2"
                                size="mini"
                                type="primary"
                                @click="handleEdit('编辑榜单', scope.row)">编辑</el-button>
                        <el-button
                                v-if="selectedStyleIndex===3"
                                size="mini"
                                type="primary"
                                @click="handleEdit('编辑联动推荐', scope.row)">编辑</el-button>
                        <el-button size="mini" type="success"   @click="showSelectorDialog(scope.row)">选品</el-button>
                        <el-button size="mini" type="warning"   @click="copyRow(scope.row)">复制</el-button>
                        <el-button size="mini"
                                   type="info"
                                   @click="handleDelete(scope.row)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-dialog :title="editDialogTitle"
                       center
                       :visible.sync="editDialogVisible"
                       @close="editDialogVisible=false"
                       width="1000px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form :model="plateEditForm">
                            <el-form-item v-if="selectedStyleIndex !==3" label="首页样式" :label-width="labelWidth">
                                <el-select disabled v-model="plateEditForm.indexStyle">
                                    <el-option
                                            v-for="item in styles"
                                            :label="item.name"
                                            :value="item.id"
                                            :key="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="selectedStyleIndex!==3" label="版块样式" :label-width="labelWidth">
                                <el-select :disabled="selectedStyleIndex===2 "  v-model="plateEditForm.plateStyle" @change="selectPlateStyle">
                                    <el-option
                                            v-for="item in styles[selectedStyleIndex]?styles[selectedStyleIndex].plateStyles:[]"
                                            :label="item.name"
                                            :value="item.id"
                                            :key="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  v-if="selectedStyleIndex===3 "   label="推荐位置" :label-width="labelWidth">
                                <el-select :disabled="target"  v-model="plateEditForm.plateStyle" @change="selectPlateStyle">
                                    <el-option
                                            v-for="item in styles[selectedStyleIndex]?styles[selectedStyleIndex].plateStyles:[]"
                                            :label="item.name"
                                            :value="item.id"
                                            :key="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="板块名称" :label-width="labelWidth">
                                <el-input v-if="selectedStyleIndex===2" style="width: 220px" type="text" maxlength="4" placeholder="不超过4个字符" v-model="plateEditForm.name"></el-input>
                                <el-input v-else style="width: 220px" type="text" maxlength="8" placeholder="不超过8个字符" v-model="plateEditForm.name"></el-input>
                            </el-form-item>
                            <el-form-item v-if="selectedStyleIndex===0" label="系统推荐" :label-width="labelWidth">
                                <el-input-number  :min="0" :max="6" tyle="width: 220px" type="text" v-model="plateEditForm.sysRecommend">
                                </el-input-number>
                            </el-form-item>
                            <el-form-item v-if="selectedStyleIndex===3" label="系统推荐" :label-width="labelWidth">
                                <el-input-number  :min="0" :max="6" tyle="width: 220px" type="text" v-model="plateEditForm.indexNum">
                                </el-input-number>
                            </el-form-item>
                            <el-form-item v-if="selectedStyleIndex!==3" label="首页展示" :label-width="labelWidth">
                                <div v-if="plateEditForm.plateStyle===undefined || selectedStyleIndex!==0" >
                                    <el-input-number :disabled="plateEditForm.plateStyle===undefined || selectedStyleIndex!==0"   tyle="width: 220px" type="text" v-model="plateEditForm.indexNum">
                                    </el-input-number>
                                </div>
                                <div v-if="plateEditForm.plateStyle===0">
                                    <el-input-number :disabled="selectedStyleIndex==1"  :min="6" :max="9" :step="3" :step-strictly=true style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">请输入6或9</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===1">
                                    <el-input-number  :disabled="selectedStyleIndex==1" :min="3" :max="50" style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">请输入[3~50]</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===2">
                                    <el-input-number :disabled="selectedStyleIndex==1" :min="1" :max="1" style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">请输入1</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===3">
                                    <el-input-number :disabled="selectedStyleIndex==1"  :min="3" :max="6" style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">请输入[3~6]</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===4">
                                    <el-input-number :disabled="selectedStyleIndex==1" :min="5" :max="5" style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">请输入5</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===5">
                                    <el-input-number  :disabled="selectedStyleIndex==1" :min="4" :max="12" :step="4" :step-strictly=true style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">输入4,8或12</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===6">
                                    <el-input-number :disabled="selectedStyleIndex==1"  :min="4" :max="6" style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag  type="danger">请输入4或6</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===9">
                                    <el-input-number  :disabled="selectedStyleIndex==1" :min="4" :max="4" style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag  type="danger">请输入4</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===10">
                                    <el-input-number  :disabled="selectedStyleIndex==1" :min="3"   style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">请大于2</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===18">
                                    <el-input-number  :disabled="selectedStyleIndex==1" :min="4"  :max="100" :step="2" :step-strictly=true style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">输入输入[4~100]</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===666">
                                    <el-input-number  :disabled="selectedStyleIndex==1" :min="4"  :max="100" :step="2" :step-strictly=true style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">输入输入[4~100]</el-tag>
                                </div>
                                <div v-if="plateEditForm.plateStyle===777">
                                    <el-input-number  :disabled="selectedStyleIndex==1" :min="4"  :max="100" :step="2" :step-strictly=true style="width: 220px" type="text" v-model="plateEditForm.indexNum"></el-input-number>
                                    &emsp;<el-tag type="danger">输入输入[4~100]</el-tag>
                                </div>
                            </el-form-item>
                            <el-form-item label="展示总量" :label-width="labelWidth">
                                <div >
                                    <el-input-number :disabled="selectedStyleIndex===1 || selectedStyleIndex===2" :min="1" :max="500" style="width: 220px" type="text" v-model="plateEditForm.totalNum"></el-input-number>
                                    <el-tag type="danger">上限500</el-tag>
                                </div>
                            </el-form-item>
                            <el-form-item label="渠道选择" :label-width="labelWidth">
                                <el-cascader  v-model="plateEditForm.subChannels" :options="channelList" :props="optionProps" clearable collapse-tags placeholder="请选择" >
                                </el-cascader>
                            </el-form-item>
                            <div style="text-align: center;">
                                <el-button type="primary" @click="confirmEditFormDialog">确 定</el-button>
                                <el-button type="info" @click="editDialogVisible=false">取 消</el-button>
                            </div>
                        </el-form>
                    </el-col>
                    <el-col :span="12" style="text-align: center; height: 100%;" >
                        <h3>
                            <i @click="scrollPlateStyle(-1)" class="el-icon-back"  style="padding-right: 50px;"/>
                            {{selectedPlateStyleTitle}}
                            <i @click="scrollPlateStyle(-1)" style="padding-left: 50px" class="el-icon-right"/>
                        </h3>
                        <div>
                            <el-image :src="selectedPlateStyleImg"/>
                        </div>
                    </el-col>
                </el-row>
            </el-dialog>
        </div>

        <div>
            <el-dialog title="选品管理"
                       center
                       :visible.sync="selectorDialogVisible"
                       @open="plateInfo"
                       @close="selectorDialogVisible=false"
                       :close-on-click-modal="false"
                       :show-close="false"
                       :destroy-on-close="true"
                       width="1500px">
                <h4>板块名称:<font size="6" bold>{{plateInfo().name}}</font>
                    板块样式:<font size="6" bold>{{plateInfo().plateStyle!==undefined?plateInfo().plateStyle.name:'---'}}</font> </h4>
                <div style="margin-bottom: 10px;">
                    <span >游戏名称：</span>
                    <el-select v-model="queryGameSelector.gameIds" multiple filterable placeholder="请选择/输入">
                        <el-option
                                v-for="item in gameSelectorList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- 默认查询业务为208 -->
                    <span >业务类型：</span>
                    <el-select v-model="queryGameSelector.dept" clearable  placeholder="请选择/输入">
                                <el-option
                                        v-for="item in deptConst"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                    </el-select>
                    <span > 游戏标签：</span>
                    <el-cascader v-model="queryGameSelector.gameLabels" :options="labelList" :props="{ key:'id',value:'id', label:'name',multiple:true }" clearable collapse-tags></el-cascader>
                    <br>
                    <span >记录日期：</span>
                    <el-date-picker
                        v-model="searchDateRange"
                        type="daterange"
:clearable="false"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                    <span >渠道筛选：</span>
                    <el-cascader v-model="queryGameSelector.subChannelIds" :options="channelList" :props="optionProps" clearable collapse-tags >
                    </el-cascader>
                    <el-button  type="primary" @click="queryGameList">查询</el-button>
                    <table>
                        <tr>
                            <td>
                                <el-button  type="primary" @click="clearAllSelected">一键清除</el-button>
                            </td>
                            <td>
                                <el-upload :action="upload()" :headers="headers"
                                           :on-success="handleSuccess"
                                           :before-upload="beforeUpload"
                                           :show-file-list="false"
                                           v-loading.fullscreen.lock="loading" :disabled="disable"
                                           ref="upload">
                                    <el-button size="medium" type="primary" :disabled="disable">导入</el-button>
                                    <span style="color:crimson">当前只能导入一次， 导入成功后如需重新导入请关闭页面后，再重新打开。</span>
                                </el-upload>
                            </td>
                        </tr>
                    </table>
                </div>
                <template  >
                    <h4>选择游戏（最少4个)</h4>
                    <!-- .slice((pagination.pageNumber-1)*pagination.size,pagination.pageNumber*pagination.size) -->
                    <el-table border
                              ref="multipleTable"
                              :data="gameList"
                              :row-class-name="gameRowTableClass"
                              stripe
                              tooltip-effect="dark"
                              style="width: 100%"
                              :row-key="getRowKeys"
                              @selection-change="handleSelectionChange"
                               @sort-change="sort_change"
                               @filter-change="filterTagTable"
                              >
                        <el-table-column
                                type="selection"
                                :reserve-selection="true"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="编号"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="游戏类型" align="center">
                            <el-table-column
                                    prop="name"
                                    label="游戏名称">
                            </el-table-column>
                            <el-table-column
                                    prop="dept"
                                    label="业务类型">
                            </el-table-column>
                            <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                    label="游戏标签">
                            </el-table-column>
                        </el-table-column>
                        <!--  :filter-method="filterState"  -->
                        <el-table-column
                                label="状态"
                                align="center"
                                :filters="[{ text: '已选', value: 1  }, { text: '未选', value: 0 }]"
                                :filter-multiple="false"
                                prop="id"
                                :column-key=" 'statusFlag' "
                                show-overflow-tooltip
                                >
                            <template slot-scope="scope" >
                                <el-tag type="success" v-if=" selectGameIds.has(scope.row.id)">已选中</el-tag>
                                <el-tag type="info" v-else>未选中</el-tag>
                                <!-- <span v-if="selectGameIds.has(scope.row.id)"><font color="#7cfc00">已选中</font></span>
                                <span v-else><font color="#808080">未选中</font></span> -->
                            </template>
                        </el-table-column>
                        <!-- :formatter="formatSquare"  :filter-method="filterSquare" -->
                        <el-table-column
                                prop="squareIcon"
                                label="大图标"
                                align="center"
                                :filters="[{ text: '有', value: 1  }, { text: '无', value: 0 }]"
                                :filter-multiple="false"
                                :column-key=" 'squareFlag' "
                                >
                            <template slot-scope="scope" >
                                <el-tag type="success" v-if="scope.row.squareIcon && scope.row.squareIcon !=''">有</el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <!-- :formatter="formatBanner" :filter-method="filterBanner" -->
                        <el-table-column
                                prop="bannerIcon"
                                :column-key=" 'bannerFlag' "
                                label="banner"
                                align="center"
                                :filters="[{ text: '有', value: 1 }, { text: '无', value: 0 }]"
                                :filter-multiple="false"
                                >
                            <template slot-scope="scope" >
                                <el-tag type="success" v-if="scope.row.bannerIcon && scope.row.bannerIcon !=''">有</el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <!-- :formatter="formatVideo" :filter-method="filterVideo" -->
                        <el-table-column
                                prop="microVideo"
                                :column-key=" 'videoFlag' "
                                label="视频"
                                align="center"
                                :filters="[{ text: '有', value: 1 }, { text: '无', value: 0 }]"
                                :filter-multiple="false"
                                >
                            <template slot-scope="scope" >
                                <el-tag type="success" v-if="scope.row.microVideo && scope.row.microVideo !=''">有</el-tag>
                                <el-tag type="info" v-else>无</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="吸量" align="center">
                            <el-table-column prop="avgUserClickPoint" sortable="custom" label="平均用户点击率" :formatter="formatterPercent" >
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="活跃" align="center">
                            <el-table-column prop="avgDayAliveUserPercent" sortable="custom" label="平均日活用户" >
                            </el-table-column>
                            <el-table-column sortable="custom" prop="sumActivityUserCount" label="累计活跃用户">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="sumPlayCount" label="累计游戏频次">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="质量" align="center">
                            <el-table-column sortable="custom" prop="avgPersonPlayCount" label="人均游戏频次">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="avgPersonPlayDuration" label="人均游戏时长">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="avgSecondaryPercent" label="平均次日留存率"  :formatter="formatterPercent">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="新品" align="center">
                            <el-table-column sortable="custom" prop="dtCreate" :formatter="formatDate" label="游戏发布时间">
                            </el-table-column>
                            <el-table-column sortable="custom" prop="dtUpdate" :formatter="formatDate" label="游戏更新时间">
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                    <div>
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="queryGameSelector.page"
                                :page-sizes="[5, 10,30,50,70,90,100,2000]"
                                :page-size="queryGameSelector.size"
                                layout="total, sizes, prev, pager, next"
                                :total="totalElements">
                        </el-pagination>
                    </div>
                </template>
                <template v-if="selectedGameList.length>0">
                    <h4>已经选择的游戏</h4>
                    <el-table border
                              :data="selectedGameList"
                              tooltip-effect="dark"
                              style="width: 100%">
                        <el-table-column
                                type="index"
                                label="编号"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="游戏名称">
                        </el-table-column>
                        <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                label="游戏分类">
                        </el-table-column>
                        <el-table-column label="标签" align="center">
                            <template slot-scope="scope" >
                                <el-select v-model="scope.row.label" placeholder="请选择" >
                                    <el-option @change="disable=true"
                                            v-for="item in labels"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="特效" align="center" width="150px">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.highLight"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="有"
                                        inactive-text="无"
                                           @change="disable=true"
                                        >
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="排序" prop="rank" align="center">
                            <template slot-scope="scope" >
                                <el-input-number size="mini" v-model="scope.row.rank" @change="disable=true"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="maxPlaying"
                                label="最大在玩人数"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="minPlaying"
                                label="最小在玩人数"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger"
                                           @click.native.prevent="deleteRow(scope.$index, scope.row)">移除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <el-form>
                    <el-form-item>
                        <template>
                            <div class="block">
                                <h4>设置生效时间:
                                    <el-date-picker
                                            v-model="useTime"
                                            type="datetime"
                                            placeholder="选择日期时间"
                                    >
                                    </el-date-picker>
                                </h4>
                            </div>
                        </template>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmAddSelect(selectedGameList,plateInfo().id,useTime)">确 定</el-button>
                        <el-button type="info" @click="closeSelectorFormDialog()">返 回</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        listRulesByPlateStyles,
        searchListRulesByChannel,
        allIndexStyles,
        allLabels,
        editPlate,
        deletePlate,
        rankEdit,
        //plateRankDown,
        //plateRankUp,
        //gameSearch,
        listSelector,
        editValidDate,
        selectorList,
        //gameReportList,
        //batchDelete,
        batchSubChannelAdd,
        batchAdd,
        gameSelectorSearch,
        updatePlateState,
        // gameList,
        gameRunningList,
        allGameLabels
    } from "@/http/api";

    import store from '@/store'
    import utils from '@/utils'
    import {channelList} from "../../http/api";

    export default {
        inject:['reload'],
        name: "IndexConfig",
        methods: {
            //百分比通用格式化
            formatterPercent: function (row, column, cellValue){
                return cellValue+"%";
            },
            formatGameLabels: function(row, column, cellValue) {
                var name="无";

                if(cellValue!=null && cellValue.length>0){
                   return  cellValue  ;
                } 
                return name;
            },
            changeStyle: function(tab){
                let _this= this;
                this.$store.commit('changeSelectedStyleIndex', tab.name);
                this.selectedStyleIndex = parseInt(tab.name);
                this.selectedPlateStyle = 0;
                this.plateEditForm.indexStyle = parseInt(tab.name);
                this.plateEditForm.plateStyle = undefined;
                //默认查询板块规则时需要设置已选游戏set集合
                listRulesByPlateStyles(tab.name).then(resp=>{
                    //---------------------------------------------------------------------------------------------优化已选游戏
                this.rules = resp.data.info.sort(function(a,b){return a.rank-b.rank});
                //置空已选游戏set
                _this.selectGameIds=new Set();
                this.rules.forEach(function (rule){
                                 rule.subChannels.forEach(function (sub) {
                                   _this.subChannelNames.push(sub.subChannel.name);
                                //    _this.channelNames.push(sub.subChannel.channelName);
                             });
                         _this.$set(rule,'subChannelNames',_this.subChannelNames);
                        //  _this.$set(rule,'channelNames',[...new Set(_this.channelNames)] );
                         _this.subChannelNames=[];
                        //  _this.channelNames=[];
                     //设置当前全部渠道已选游戏set
                        rule.games.forEach(function (games){
                            _this.selectGameIds.add(games.game.id);
                        })
                   })
                })
            },
            searchListRules:function(){
                let _this= this;
                searchListRulesByChannel(this.selectedStyleIndex,this.queryData.subChannels).then(resp=>{
                    this.rules = resp.data.info.sort(function(a,b){return a.rank-b.rank});
                    //置空已选游戏set
                    _this.selectGameIds=new Set();
                    this.rules.forEach(function (rule){
                        rule.subChannels.forEach(function (sub) {
                            _this.subChannelNames.push(sub.subChannel.name);
                            // _this.channelNames.push(sub.subChannel.channelName);
                        });
                        _this.$set(rule,'subChannelNames',_this.subChannelNames);
                        // _this.$set(rule,'channelNames',[...new Set(_this.channelNames)]);
                        _this.subChannelNames=[];
                        // _this.channelNames=[];
                        //设置当前全部渠道已选游戏set
                        rule.games.forEach(function (games){
                            _this.selectGameIds.add(games.game.id);
                        })
                    });
                })
            },
            selectPlateStyle: function(_plateStyleId){
                let plateStyles = this.styles[this.selectedStyleIndex].plateStyles;
                let idx = 0;
                for(; idx < plateStyles.length; idx++){
                    if(plateStyles[idx].id===_plateStyleId){
                        break;
                    }
                }
                this.selectedPlateStyle = idx;
                /*if (this.LinkedIds.has(_plateStyleId)){
                    this.editDialogVisible=false;
                    return this.$message.error("板块已存在");
                }*/
            },
            scrollPlateStyle: function(gap){
                if (this.selectedStyleIndex===3 && this.target===true){
                    return;
                }
                this.selectedPlateStyle += gap;
                if(this.selectedPlateStyle<0){
                    this.selectedPlateStyle = this.styles[this.selectedStyleIndex].plateStyles.length-1;
                }else if(this.selectedPlateStyle>=this.styles[this.selectedStyleIndex].plateStyles.length){
                    this.selectedPlateStyle = 0;
                }
               if (this.editDialogTitle!=='编辑版块')
                this.plateEditForm.plateStyle = this.styles[this.selectedStyleIndex].plateStyles[this.selectedPlateStyle].id;
            },
            handleEdit: function(title, row){
                this.target=false;
                this.plateEditForm = {
                    "id": 0,
                    "name": "",
                    "indexStyle": this.selectedStyleIndex,
                    "plateStyle": undefined,
                    "indexNum": 1,
                    "totalNum": 0,
                    "sysRecommend":0,
                    "subChannels":[],
                };

                if (title==='新增榜单'){
                    this.plateEditForm = {
                        "id": 0,
                        "name": "",
                        "indexStyle": this.selectedStyleIndex,
                        "plateStyle": 11,
                        "sysRecommend":0,
                        "indexNum": 1,
                        "totalNum": 0,
                        "subChannels":[],
                    };
                }

                if (title==='新增联动推荐'){
                    this.plateEditForm = {
                        "id": 0,
                        "name": "",
                        "indexStyle": this.selectedStyleIndex,
                        "plateStyle": undefined,
                        "indexNum": 1,
                        "totalNum": 50,
                        "sysRecommend":0,
                        "subChannels":[],
                    };
                    /*this.rules.forEach(function (rule) {
                        _this.LinkedIds.add(rule.plateStyle.id)
                    })*/

                }

                this.editDialogTitle = title;
                this.editDialogVisible = true;

                if(row){
                    let _this =this;
                    row.subChannels.forEach(function (sub) {
                        _this.editSubChannels.push(sub.subChannel.subChannel)
                    });

                    this.target=true;
                    this.plateEditForm = {
                        "id": row.id,
                        "name": row.name,
                        "indexStyle": row.indexStyle.id,
                        "plateStyle": row.plateStyle,
                        "indexNum": row.indexNum,
                        "sysRecommend": row.sysRecommend,
                        "totalNum": row.totalNum,
                        "subChannels":this.editSubChannels,
                    };
                    this.selectPlateStyle(row.plateStyle)
                    this.editSubChannels=[];
                }
            },
            tableRowClass: function(row){
                if(row.rowIndex%2===1){
                    return 'row_odd_class'
                }
                return ''
            },
          /*  handleRank: function(_act, _id){
                let func = plateRankUp;
                if(_act==='down'){
                    func = plateRankDown
                }
                func(_id).then(resp=>{
                    if(resp.data.status===0){
                        this.reload();
                    }
                })
            },*/
            handleRank:function(_id, _rank){
                rankEdit(_id,_rank).then(resp=>{
                    if(resp.data.status===0){
                        console.log("ok");
                    }
                });
            },
            handleDelete: function(row){
                this.$confirm('确认是否删除?', '警告', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    deletePlate(row.id).then(resp=>{
                        if(resp.data.status===0){
                            this.searchListRules();
                        }
                    })
                }).catch(()=>{
                })
            },
            showSelectorDialog: function(row){
                this.disable=false;
                this.selectorDialogVisible=true;
                this.rule=row;
                 this.queryGameSelector={
                    "gameIds": [],
                    "gameLabels": [],
                    "gameLabelIds": [],
                    "state": 1,
                    "startTime": '',
                    "endTime": '',
                    "subChannelIds": [],
                    "prop": '',
                    "order": '',
                    "page": 1,
                    "size": 10,
                    "statusFlag" : -1 ,
                    "selectAllGameIds" : [],
                    "squareFlag" : -1,
                    "bannerFlag" : -1,
                    "videoFlag" : -1,
                    "dept":"208"
                };
                //展示前清空临时已选游戏列表
                this.tempSelectedGameList=[];
                this.selectedGameList=[];
                //=========================================================初始化已选游戏列表
                //获取已选择的游戏信息 传入
                    listSelector(this.rule.id).then(resp=>{
                        //设置临时已经选择的list
                    if (resp.data.info){
                        resp.data.info.forEach((info)=>{
                            //这里查询获取到的已经选择游戏
                            this.selectedGameList.push(info.game)
                        });
                    }
                        //调用通用数据处理方法
                        this.gameSelectorTemp();
                        });
                //设置生效日期
                this.useTime=new Date(row.validDate);
                this.headers = {Authorization: this.$store.state.user.token};
            },
            confirmEditFormDialog: function(){
                let _message = '';
                let plateToSubChannel = [];
                if(this.plateEditForm.plateStyle===undefined){
                    _message = '请选择版块样式'
                }else if(this.plateEditForm.name===''){
                    _message = '请输入版块名称'
                }else if (this.plateEditForm.sysRecommend<0){
                    _message = '推荐数量不正确'
                } else if(this.plateEditForm.indexNum<0){
                    _message = '首页展示数量不正确'
                }else if(this.plateEditForm.totalNum<this.plateEditForm.indexNum){
                    _message = '展示总量数据不正确'
                }else  if(this.plateEditForm.subChannels.length===0){
                    _message = '请选择渠道'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                this.plateEditForm.subChannels.forEach(function (subChannel) {
                    plateToSubChannel.push({subChannel:{subChannel:subChannel}});
                });

                editPlate(this.plateEditForm).then(resp=>{
                    if(resp.data.status===0){

                        batchSubChannelAdd(resp.data.info,plateToSubChannel).then(resp=>{
                            if (resp.data.status===0){
                                this.searchListRules();
                                this.editDialogVisible = false;
                            }
                        }).catch(function () {});
                    }
                })
            },
            // 游戏选品     点击游戏复选框处理逻辑
            handleSelectionChange (val) {
                this.disable = true;
                let _this  =this;
                //console.log('select', val)
                val.forEach(function (game) {
                    //设置默认值
                    _this.$set(game,'rank',0);
                    _this.$set(game,'label',0);
                    _this.$set(game,'highLight',0);
                    _this.selectedGameList.forEach(function (gameSelector) {
                        if (game.id === gameSelector.id){
                            _this.$set(game,'rank',gameSelector.rank);
                            _this.$set(game,'label',gameSelector.label);
                            _this.$set(game,'highLight',gameSelector.highLight)
                        }
                    })
                });
                _this.tempSelectedGameList=val
            },
            //游戏选品 移除按钮
            deleteRow(index, row) {
                this.disable=true
                this.selectedGameList.splice(index, 1);
                this.gameList.forEach(item => {
                    if(item.id === row.id) {
                        this.$refs.multipleTable.toggleRowSelection(item,false);
                        this.tempSelectedGameList.forEach((game, index) => {
                            //如果删除的是临时的游戏选品 而不是已经选好的 需要清除对应templist
                            if (game.id === row.id) this.tempSelectedGameList.splice(index, 1)
                        })
                    }
                })
            },
            update(row){
                updatePlateState(row.state,row.id).then(resp=>{
                    if (resp.data.msg==='成功'){
                        this.searchListRules();
                    }
                });
            },
            copyRow(row){
                let plate_id;
                let gameSelectors =[];
                let plateToSubChannel = [];
                let _this =this;
                row.subChannels.forEach(function (sub) {
                    _this.editSubChannels.push(sub.subChannel.subChannel)
                });
                this.plateEditForm = {
                    "id": 0,
                    "name": row.name,
                    "indexStyle": row.indexStyle.id,
                    "plateStyle": row.plateStyle,
                    "indexNum": row.indexNum,
                    "totalNum": row.totalNum,
                    "sysRecommend":row.sysRecommend,
                    "subChannels":this.editSubChannels,
                };
                this.plateEditForm.subChannels.forEach(function (subChannel) {
                    plateToSubChannel.push({subChannel:{subChannel:subChannel}});
                });
                editPlate(this.plateEditForm).then(resp=>{
                    if(resp.data.status===0){
                        plate_id=resp.data.info;
                        batchSubChannelAdd(resp.data.info,plateToSubChannel).then(resp=>{
                            if (resp.data.status===0){
                                if (row.games.length>0){
                                    row.games.forEach(function (game) {
                                        gameSelectors.push({game:{id:game.game.id},
                                            rank:game.rank,label:game.label});
                                    });
                                    batchAdd(plate_id,gameSelectors).then(resp=>{
                                        if (resp.data.status===0){
                                            editValidDate(plate_id,new Date(row.validDate).getTime());
                                        }
                                    }).catch(function () {});
                                }
                            }
                        }).catch(function () {});

                        updatePlateState(0,plate_id).then(resp=>{
                            if (resp.data.status===0){
                                this.searchListRules();
                            }
                        })
                        }
                });
                this.editSubChannels=[];
            },
            gameRowTableClass({row,rowIndex}){
                row.index=rowIndex
            },
            //确认游戏选品操作-----------------------------------优化
            confirmAddSelect(preList,id,dt){
                // console.log(preList)
                let _this = this;
                let gameSelectors =[];
                let obj = {};
                //构造新的游戏选品list 传给后台
               gameSelectors=  preList.reduce((cur, next) => {
                            obj[next.id] ? "" : (obj[next.id] = true && cur.push({game:{id:next.id},
                        rank:next.rank,label:next.label,highLight:next.highLight}));
                            return cur;
                        },[]); 
            //    console.log(gameSelectors)
                //这里 改成传入  在后台进行已有数据清空
                batchAdd(_this.plateInfo().id,gameSelectors).then(resp=>{
                    if (resp.data.status===0){
                        //更新时间
                        editValidDate(id,dt.getTime());
                        _this.searchListRules();
                    }
                }).catch(function () {});
                //调用关闭dialog接口
                this.closeSelectorFormDialog();
            },
            getRowKeys(row){
                return row.id
            },
            plateInfo:function(){
                return this.rule;
            },
            closeSelectorFormDialog:function () {
                this.selectedGameList=[];
                this.tempSelectedGameList=[];
                this.selectorDialogVisible=false;
            },
            handleSizeChange(newSize){
                this.queryGameSelector.size=newSize;
                this.gameSelectorTemp()
            },
            handleCurrentChange(newPage){
                this.queryGameSelector.page=newPage;
                this.gameSelectorTemp()
            },
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            filterTagTable(filters){
                // console.log("aaa:",filters,"2222")
                if(filters.statusFlag ){
                    // console.log("设置statusFlag")
                    //标志位
                this.queryGameSelector.statusFlag = filters.statusFlag[0];
                    //设置渠道已选游戏id
                this.queryGameSelector.selectAllGameIds =  [...this.selectGameIds];
                }else{
                    // console.log("清空statusFlag")
                this.queryGameSelector.statusFlag = -1;
                this.queryGameSelector.selectAllGameIds = [];
                }
                if(filters.squareFlag){
                    //设置大图标标志位
                this.queryGameSelector.squareFlag = filters.squareFlag[0]
                }else{
                    this.queryGameSelector.squareFlag =-1
                }
                if(filters.bannerFlag){
                    //设置banner 标志位
                this.queryGameSelector.bannerFlag = filters.bannerFlag[0]
                }else{
                    this.queryGameSelector.bannerFlag = -1
                }
                if(filters.videoFlag){
                    //设置videoFlag
                this.queryGameSelector.videoFlag = filters.videoFlag[0]
                }else{
                    this.queryGameSelector.videoFlag = -1
                }
                this.gameSelectorTemp() // 筛选所选项下的所有数据，需要调用后端接口
            },
            //-----------------------------------------优化
            queryGameList(){
                if(this.searchDateRange && this.searchDateRange[0] && this.searchDateRange[1]){
                    this.queryGameSelector.startTime=this.searchDateRange[0];
                    this.queryGameSelector.endTime=this.searchDateRange[1]
                }else{
                     this.queryGameSelector.startTime='';
                     this.queryGameSelector.endTime=''
                }
                //todo  判断排序 页数置1
                this.queryGameSelector.page=1;
                this.gameSelectorTemp()
            },
            gameSelectorTemp() {
                //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
                this.flag = false;
                //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
                this.gameList.forEach(item => {
                    this.$refs.multipleTable.toggleRowSelection(item,false);
                })
                let newLabelIds =[];// eslint-disable-line no-unused-vars
                 this.queryGameSelector.gameLabels.forEach(function (label) {
                      label.forEach(function (sub,index) {
                         if(index%2!==0){
                             newLabelIds.push(sub);
                         }
                      })
                 });
                 this.queryGameSelector.gameLabelIds=newLabelIds;
                // console.log("查询Selector",this.queryGameSelector)
                gameSelectorSearch(this.queryGameSelector).then(resp=>{
                    this.gameList=resp.data.info.content;
                    this.totalElements=resp.data.info.totalElements;
                     //获取已选中游戏id
                    const ids = [];
                    this.selectedGameList.length && this.selectedGameList.forEach(item => {
                        ids.push(item.id)
                    });
                    //临时temp数组
                    const tempSelectedGameList = [];
                    //console.log('xxxx', ids)
                    //判断当前页是否有已选中游戏 如果有设置已勾选
                    ids.length && this.gameList.forEach(item => {
                        if (ids.indexOf(item.id) > -1) {
                            tempSelectedGameList.push(item);
                            this.$refs.multipleTable.toggleRowSelection(item,true);
                        }
                    });
                    this.disable=false;
                    //console.log('new page: ', tempSelectedGameList)
                    //赋值
                    this.tempSelectedGameList = tempSelectedGameList;
                    //渲染 并设置flag为true
                    this.$nextTick(() => this.flag = true)
                });
            },
            // 排序优化
            sort_change(column) {
                this.queryGameSelector.page=1;
                //如果列空则条件清空  如果order为null手动置为空字符串 如果其他情况设置字段
                 if(column.prop == null ){
                     this.queryGameSelector.prop = "";
                     this.queryGameSelector.order = ""
                }else {
                    if( column.order == null){
                    this.queryGameSelector.order = ""
                    }else {
                        this.queryGameSelector.order = column.order
                    }
                    this.queryGameSelector.prop = column.prop
                }
                this.gameSelectorTemp()
            },
            clearAllSelected() {
                //清除全部已选游戏
                //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
                // this.flag = false
                //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
                // this.gameList.forEach(item => {
                //     this.$refs.multipleTable.toggleRowSelection(item,false);
                // })
                 this.$refs.multipleTable.clearSelection();
                 this.selectedGameList=[];
                 this.tempSelectedGameList=[];
                 this.disable=true;
                // this.flag=true;
            },
            handleSuccess(data){
                console.log(data);
                this.selectorDialogVisible=true;
                this.queryGameSelector={
                    "gameIds": [],
                    "state": 1,
                    "startTime": '',
                    "endTime": '',
                    "subChannelIds": [],
                    "prop": '',
                    "order": '',
                    "page": 1,
                    "size": 10,
                    "statusFlag" : -1 ,
                    "selectAllGameIds" : [],
                    "squareFlag" : -1,
                    "bannerFlag" : -1,
                    "videoFlag" : -1,
                    "dept":""
                };
                //展示前清空临时已选游戏列表
                this.tempSelectedGameList=[];
                this.selectedGameList=[];
                //=========================================================初始化已选游戏列表
                //获取已选择的游戏信息 传入

                    if (data.info){
                        data.info.forEach((info)=>{
                            //这里查询获取到的已经选择游戏
                            this.selectedGameList.push(info.game)
                        });
                    }
                    //调用通用数据处理方法
                    this.gameSelectorTemp();
                //设置生效日期
                this.useTime=new Date(this.rule.validDate);
                this.headers = {Authorization: this.$store.state.user.token};
                this.disable=true;
            },
            beforeUpload(data){
                console.log(data);
            },
            upload() {
                return this.VUE_APP_BASE_URL + 'plate/selector/list/excel/'+this.rule.id;
            },
        },

        watch:{

            tempSelectedGameList: {
                handler(val, oldVal) {
                    //console.log('tempSelectedGameList', val, oldVal)
                    //如果是加载数据阶段设置勾选时 不进行监听直接返回
                    if (!this.flag) return
                    //新增数据判断
                    const isAdd = val.length > oldVal.length;
                    const oldArr = [], arr = [];
                     oldVal.forEach((item) => {
                        oldArr.push(item.id)
                    });
                    val.forEach((item) => {
                        arr.push(item.id)
                    });
                    //console.log('arr', oldArr, arr)
                    if (isAdd) {
                        let result = [];
                        arr.forEach(id => {
                            //把新增的数据项push进结果中 result
                           if (oldArr.indexOf(id) === -1) {
                               result.push(id)
                           }
                        });
                        result.forEach(id => {
                            //新数据中如果 id为新增数据项已经初始化之后了ranklabel 则添加到selectedGameList最终结果中
                            val.forEach((item) => {
                                if (item.id === id) this.selectedGameList.push(item)
                            })
                        })
                    } else {
                        //删除时
                        let result = [];
                        oldArr.forEach(id => {
                            //把删除的id找出来
                           if (arr.indexOf(id) === -1) {
                               result.push(id)
                           }
                       });
                       //把selectedGameList中对应resultId 删除
                       result.forEach(id => {
                           this.selectedGameList.forEach((item, index) => {
                               if (item.id === id) this.selectedGameList.splice(index, 1)
                           })
                       })
                    }
                }
            },

            selectedStyleIndex(){
                this.queryData.subChannels=[];
            }
        },
        filters: {
        ellipsis(value, limit) {
                if (!value) return ''
                if (value.length > limit) {
                        return value.slice(0, limit) + '...'
                }
                return value
    },
},

        computed: {
            // 这里拼接的本地图片样式地址
            selectedPlateStyleImg: function(){
                return require('@/assets/style_'+this.selectedStyleIndex+'_'+this.selectedPlateStyle+'.png');
            },
            selectedPlateStyleTitle: function(){
                if(this.styles
                    &&this.styles[this.selectedStyleIndex]
                    &&this.styles[this.selectedStyleIndex].plateStyles
                    &&this.styles[this.selectedStyleIndex].plateStyles[this.selectedPlateStyle]
                ){
                    return this.styles[this.selectedStyleIndex].plateStyles[this.selectedPlateStyle].name
                }else{
                    return ""
                }
            }
        },
        mounted() {
            this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        },
        data () {
            return {
                disable:false,
                headers: {},
                loading: false,
                VUE_APP_BASE_URL:null,
                editSubChannels:[],
                target:false,
                newStyles:[],
                labelWidth: '100px',
                editDialogVisible: false,
                selectorDialogVisible:false,
                editDialogTitle: '',
                //模块编辑的数据对象
                plateEditForm: {
                    "id": 0,
                    "name": "",
                    "indexStyle": 0,
                    "plateStyle": 0,
                    "indexNum": 1,
                    "totalNum": 0,
                    "sysRecommend":0,
                    "subChannels":[],
                },
                optionProps: {
                    emitPath:false,
                    multiple:true,
                    value:'subChannel',
                    label: 'name',
                    children: 'children',
                },
                selectedPlateStyle: 0,
                selectedStyleIndexString: store.state.ruleConfig.selectedStyleIndex+"",
                //选中的首页样式索引值
                selectedStyleIndex: store.state.ruleConfig.selectedStyleIndex,
                //所有的首页样式
                styles: [
                    {
                        plateStyles:[]
                    }
                ],
                //版块列表数据
                rules: [
                ],
                //游戏列表
                gameList:[],
                //每行板块
                rule:{},
                //最终选中的列表
                selectedGameList:[],
                //临时新增展示的列表
                tempSelectedGameList:[],
                defaultGameSelectorFlag:false,
                //判断是否进行监听selectedGameList 标志位
                flag: false,
                subQueryData:{
                },
                queryData:{
                    subChannels:[],
                },
                pagination:{
                    size:10,
                    pageNumber:1,
                },
                selectGameIds:new Set(),
                channelList:[],
                //子渠道集合
                subChannelList:[],
                //子渠道号集合
                subChannels:[],
                //子渠道名称集合
                subChannelNames:[],
                //渠道名称集合
                // channelNames:[],
                //生效时间
                useTime:'',
                //LinkedIds:new Set(),
                labels:[],
                //游戏选品中游戏列表下拉框数据 固定的
                gameSelectorList: [],
                // 游戏选品
                queryGameSelector: {
                    "gameIds": [],
                    "gameLabelIds":[],
                    "state": 1,
                    "startTime": '',
                    "endTime": '',
                    "subChannelIds": [],
                    "prop": '',
                    "order": '',
                    "page": 1,
                    "size": 10,
                    "statusFlag" : -1 ,
                    "selectAllGameIds" : [],
                    "squareFlag" : -1,
                    "bannerFlag" : -1,
                    "videoFlag" : -1,
                    "dept":''
                },
                //游戏选品总数
                totalElements :0,
                //查询日期区间
                searchDateRange:[],
                pickerMinDate:'',
                pickerOptions: {
                    onPick: (time) => {
                        // this.pickerMinDate = time.minDate;
                            if(time.minDate && !time.maxDate){
                                this.pickerMinDate=time.minDate;  //将第一次选中值保存
                            }
                            if(time.maxDate){
                                this.pickerMinDate=null;
                            }
                    },
                    disabledDate:(time)=> {
                        if (this.pickerMinDate) {
                            const day1 =  7 * 24 * 3600 * 1000;
                            let maxTime = this.pickerMinDate.getTime() + day1;
                            let minTime = this.pickerMinDate.getTime() - day1;
                            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now()+1 * 24 * 3600 * 1000
                        }else{
                            return time.getTime() > Date.now()+24 * 3600 * 1000
                        }
                    }
                },
                // 业务组常量 目前写死 
                deptConst:[{id:0,name:'全部',value:null},
                    {id:1,name:'208',value:"208"},
                    {id:2,name:'211',value:"211"}],
                // 游戏标签
                labelList:[],
            }
        },


        created () {
            allIndexStyles().then(resp=>{
                //取前4个枚举类型便于后期拓展  获取到的是菜单页的枚举其中包含里层枚举类plateStyle
                this.styles = resp.data.info.filter(style =>style.id !==5 && style.id!==4);
                this.newStyles = resp.data.info.filter(style =>style.id !==5 && style.id!==1 && style.id!==4);
                this.changeStyle({name: this.selectedStyleIndex+''})
            });
            //没问题    默认设置该渠道全部已选游戏id作为set 标志位
            selectorList().then(resp=>{
                let _this= this;   
                resp.data.info.forEach(function (gameId) {
                    _this.selectGameIds.add(gameId);
                })
            });
            // gameReportList().then(resp=>{
            //     this.gameReportList = resp.data.info;
            // });
            channelList().then(resp=>{
                let _this = this;
                this.channelList=JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                    if (channel.children) {
                        channel.children = channel.children.filter(sub => sub.state === 1)
                    }
                    return channel;
                }).filter(channel => channel.children && channel.children.length);
                this.channelList.forEach(function (channel) {
                    _this.$set(channel,'subChannel',channel.id);
                    channel.children.forEach(function (sub) {
                        _this.subChannelList.push(sub);
                        _this.subChannels.push(sub.subChannel);
                    })
                })
            });
            // 游戏选品的游戏下拉框数据及外城游戏查询条件初始化  只需要id name
            gameRunningList().then(resp=>{
                 this.gameSelectorList=resp.data.info;
            });
            //获取全部标签类型
            allLabels().then(resp=>{
                this.labels = resp.data.info;
            });
            // 获取游戏标签
            allGameLabels().then(resp=>{
                this.labelList=resp.data.info;
            })
        },
    }
</script>

<style scoped>

</style>

<style lang="less" >
    .el-table .row_odd_class{
        background-color: #f0f0f0;
    }
    .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: rgba(0, 0, 0, 0) !important;
    }
    .btn-custom-cancel {
        float: right;
        margin-left: 10px;
    }
    .sub-sub{ position: relative; left: 15px}
    .sub-sub1{ position: relative; left: 1100px}
    .sub-sub2{ position: relative; left: 1100px}
    .sub-sub3{ position: relative; left: 1100px}
    .el-tooltip__popper{ max-width:50% }
</style>
